import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainContainer from "./maincontainer";

import Home from "./Modules/Home/home";
import ContactUs from "./Modules/Contact/Contactus";
import Pictures from "./Modules/Picture/picture";
import Videos from "./Modules/Video/Video";
import Certificate from "./Modules/Certificate/Certificate";
import PrivacyPolicy from "./Modules/PrivacyPolicy/Privacy";
import ComingSoon from "./Modules/ComingSoon/Soon";
import OurCompany from "./Modules/OurCompany/Company";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainContainer />}>
          <Route index element={<Home />} />
          <Route path="/our-company" element={<OurCompany />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/picture" element={<Pictures />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/certificate" element={<Certificate />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
